namespace GeniuzPOS.PriceChange {
    export namespace ApprovePriceChangeService {
        export const baseUrl = 'PriceChange/ApprovePriceChange';

        export declare function Create(request: Serenity.SaveRequest<ApprovePriceChangeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovePriceChangeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovePriceChangeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ApprovePriceChangeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PriceChange/ApprovePriceChange/Create",
            Update = "PriceChange/ApprovePriceChange/Update",
            Delete = "PriceChange/ApprovePriceChange/Delete",
            Retrieve = "PriceChange/ApprovePriceChange/Retrieve",
            List = "PriceChange/ApprovePriceChange/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovePriceChangeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
